import axios from "networking/axios/axios";
import * as endpoints from "networking/endpoints/endpoints";

export const registerProductApi = (data) =>
    Promise.resolve(axios.post(endpoints.registerProduct, data));
